/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ISiloModule, ISiloModuleInterface } from "../ISiloModule";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "xaiAmount",
        type: "uint256",
      },
    ],
    name: "SiloModuleWithdraw",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "silo",
        type: "address",
      },
    ],
    name: "availableXai",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "xaiAmount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "silo",
        type: "address",
      },
    ],
    name: "deposited",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "xaiAmount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_xaiAmount",
        type: "uint256",
      },
    ],
    name: "withdrawFromDeposits",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ISiloModule__factory {
  static readonly abi = _abi;
  static createInterface(): ISiloModuleInterface {
    return new utils.Interface(_abi) as ISiloModuleInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISiloModule {
    return new Contract(address, _abi, signerOrProvider) as ISiloModule;
  }
}
